<script>
    import { createEventDispatcher } from 'svelte';
    import { reduceBranch } from '../utils/branches';

    const dispatch = createEventDispatcher();

    export let branches;
    export let totalOnlyFor = null;
    export let dateLabel = 'Date';
    export let checkboxes = false;
    export let isTableHidden = true;
    export let percentsInTotal = false;
    export let percentsFor = [];
    export let additionalInTotal = {};
    export let hideTotal = false;
    export let borders = [];
    export let dateLink = false;
    export let additional = undefined;
    export let darkenBackground = [];
    export let thSmall = [];

    function handleChange(event, index) {
        dispatch('update', { fields: branches });
    }

    function handleClick() {
        isTableHidden = !isTableHidden;
    }

    let today = new Date()

    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0')
    let yyyy = today.getFullYear()

    today = yyyy+'-'+mm+'-'+dd

    if (branches[Object.keys(branches)[0]][0]?.point?.includes(':')
        || branches[Object.keys(branches)[0]][0]?.date?.includes(':')) {
        for (const key of Object.keys(branches)) {
            branches[key] = [{
                point: today,
                amount: reduceBranch(branches[key]),
            }]
        }
    }

    const limitInc = 25;
    let limit = limitInc;

    function showMore() {
        limit += limitInc;
    }

    let totalSum;

    if (totalOnlyFor) {
        totalSum = totalOnlyFor.map((idx) => Object.values(branches)[idx]).reduce((f, s) => f + s.reduce((a, b) => a + b.amount, 0), 0);
    } else if (percentsFor?.length) {
        totalSum = percentsFor.map((idx) => Object.values(branches)[idx]).reduce((f, s) => f + s.reduce((a, b) => a + b.amount, 0), 0);
    } else {
        totalSum = Object.values(branches).slice(0, Object.values(branches).length - 1).reduce((f, s) => f + s.reduce((a, b) => a + b.amount, 0), 0);
    }
</script>
<div class="wrapper">
    <div class="header" on:click={handleClick}></div>
    <table class="table">
          <thead>
              <tr>
                {#if checkboxes}
                    <th>Chart</th>
                {/if}
                <th>{dateLabel}</th>
                {#each Object.entries(branches) as [key, _], idx}
                    <th class="{borders.includes(idx) ? 'border-right' : ''} {thSmall.includes(idx) ? 'th-small' : ''}">{key}</th>
                {/each}
              </tr>
          </thead>
          <tbody class:hidden={isTableHidden}>
                {#if !hideTotal}
                <tr>
                    {#if checkboxes}
                        <td></td>
                    {/if}
                    <td><b>Total</b></td>
                    {#each Object.values(branches) as branch, idx}
                        {#if totalOnlyFor}
                            {#if totalOnlyFor.includes(idx)}
                                <td class="{borders.includes(idx) ? 'border-right' : ''}">{new Intl.NumberFormat('ja-JP').format(Math.trunc(branch.reduce((a, b) => a + b.amount, 0)))} {#if (percentsInTotal || (percentsFor.length && percentsFor.includes(idx))) && idx !== Object.values(branches).length - 1 && ((branch.reduce((a, b) => a + b.amount, 0)) * 100 / totalSum)} [{((branch.reduce((a, b) => a + b.amount, 0)) * 100 / totalSum).toFixed(1)} %] {/if}</td>
                            {:else}
                                <td></td>
                            {/if}
                        {:else}
                            <td class="{borders.includes(idx) ? 'border-right' : ''} {darkenBackground.includes(idx) ? 'darken-background' : ''}">{new Intl.NumberFormat('ja-JP').format(Math.trunc(branch.reduce((a, b) => a + b.amount, 0)))} {#if (percentsInTotal || (percentsFor.length && percentsFor.includes(idx))) && idx !== Object.values(branches).length - 1 && ((branch.reduce((a, b) => a + b.amount, 0)) * 100 / totalSum)} [{((branch.reduce((a, b) => a + b.amount, 0)) * 100 / totalSum).toFixed(1)} %]{/if} {#if Object.keys(additionalInTotal).includes(idx + '')} ({new Intl.NumberFormat('ja-JP').format(additionalInTotal[idx])}){/if}</td>
                        {/if}
                    {/each}
                </tr>
                {/if}
                {#if additional}
                <tr>
                    {#each Object.entries(additional) as [key, value], idx}
                        <td><b>{key}</b></td>
                        {#each value as val}
                            <td class="{borders.includes(idx) ? 'border-right' : ''} {darkenBackground.includes(idx) ? 'darken-background' : ''}">{val}</td>
                        {/each}
                    {/each}
                </tr>
                {/if}
                {#each [...Object.values(branches)[0]].reverse().slice(0, limit) as branch, idx}
                    <tr>
                        {#if checkboxes}
                            <td style="width: 3%;"><input type="checkbox" bind:checked={branch.checked} on:change={(event) => handleChange(event, idx)}></td>
                        {/if}
                        <td>
                            {#if dateLink}
                                <a href="{dateLink}&startDate={branch.rawDate}&endDate={branch.rawDate}" class="dateLink" target="_blank" rel="noreferrer">{branch.point || branch.date || branch.country}</a>
                            {:else}
                                {branch.point || branch.date || branch.country}
                            {/if}
                        </td>
                        {#each Object.values(branches) as _branch, _idx }
                            <td class="{borders.includes(_idx) ? 'border-right' : ''} {darkenBackground.includes(_idx) ? 'darken-background' : ''}">
                                {#if [..._branch].reverse()[idx].amount instanceof String || typeof [..._branch].reverse()[idx].amount === 'string'}
                                    {[..._branch].reverse()[idx].amount}
                                {:else}
                                    {#if Math.abs(+[..._branch].reverse()[idx].amount) < 100}
                                        {new Intl.NumberFormat('ja-JP').format(+([..._branch].reverse()[idx].amount).toFixed(2))}
                                    {:else}
                                        {new Intl.NumberFormat('ja-JP').format(Math.trunc([..._branch].reverse()[idx].amount))}
                                    {/if}
                                {/if}
                            </td>
                        {/each}
                    </tr>
                {/each}
          </tbody>
        </table>
        <div class="more-info" class:showed={isTableHidden} on:click={handleClick}>
            <p>Click to expand</p>
        </div>
</div>

{#if limit < Object.values(branches)[0].length && !isTableHidden}
    <div class="show-more">
        <button on:click={showMore} class="btn btn-primary">Show more</button>
    </div>
{/if}

<style>
    .wrapper {
        overflow-x: auto;
    }

    .table {
        width: 100%;
        margin-top: 40px;
        white-space: nowrap;
    }

    .more-info {
        width: 100%;
        text-align: center;
        background-color: #fff;
        display: none;
        cursor: pointer;
    }

    .hidden {
        display: none;
    }

    .showed {
        display: block;
    }

    .wrapper {
        position: relative;
    }

    .header {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 40px;
        cursor: pointer;
        z-index: 10;
    }

    .table th {
        background-color: #e9ecef;
        padding-left: 15px;
        padding-right: 15px;
    }

    .table tr td {
        width: 200px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .show-more {
        text-align: center;
    }

    .border-right {
        border-right: 1px solid #DEE2E6;
    }

    .darken-background {
        background-color: rgba(0, 0, 0, 0.03);
    }

    .th-small {
        font-size: 15px;
    }
</style>